export default "/_next/static/images/4e4fdb684e6bb11944cfd45297949960.jpg";